import React from 'react';
import { Button, Descriptions, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom-v5-compat';
import { createUseStyles } from 'react-jss';
import type { ConfiguredCarrierCount } from '~/store/fulfillmentContext/types';
import { useStoreState } from '~/store';

interface CarriersColumnCellProps {
  contextId: string;
  carrier: ConfiguredCarrierCount;
  carrierName: string;
  methodNames: string[];
}

const useStyles = createUseStyles({
  carrierContainer: {
    display: 'flex',
    flexDirection: 'row',

    '@media (max-width: 1439px)': {
      flexDirection: 'column',
    },
  },
  carrierLabel: {
    marginRight: '5px',
    color: 'rgba(0, 0, 0, 0.85)',
  },
});

export const CarriersColumnCell = React.memo<CarriersColumnCellProps>(function CarriersColumnCell({
  contextId,
  carrier,
  carrierName,
  methodNames,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const sessionPartnerSlug = useStoreState((state) => state?.session?.user?.sessionPartnerUrl);

  const methodText = methodNames?.map((method) => <div key={`${contextId}-${method}`}>{method}</div>);

  const pluralize = carrier.methodCount > 1 ? 's' : '';

  return (
    <Descriptions size={'small'} column={1} layout={'horizontal'}>
      <Descriptions.Item label="">
        <div className={classes.carrierContainer}>
          <div className={classes.carrierLabel}>{carrierName} :</div>
          <Button
            style={{
              height: 'auto',
              margin: 0,
              padding: 0,
              fontWeight: 'bold',
            }}
            type={'link'}
            onClick={() => navigate(`/${sessionPartnerSlug}/fulfillment-contexts/${contextId}/contracts`)}
          >
            <Tooltip placement="left" title={methodText && methodText.length > 0 ? methodText : 'None'}>
              {carrier.methodCount} active service method{pluralize}
            </Tooltip>
          </Button>
        </div>
      </Descriptions.Item>
    </Descriptions>
  );
});
